// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
export function databaseAircraftSummaryEndpoint(baseEndpoint, { includePhotos = false } = {}) {
  return `${baseEndpoint}?summary=1${includePhotos ? "&photos=1" : ""}`;
}

export async function fetchDatabaseAircraftSummary(baseEndpoint, { includePhotos = false } = {}) {
  const url = databaseAircraftSummaryEndpoint(baseEndpoint, { includePhotos });
  const response = await fetch(url, { cache: "no-store" });
  if (!response.ok) throw new Error(`Database aircraft API HTTP ${response.status}`);
  const payload = await response.json();
  return Array.isArray(payload?.aircraft) ? payload.aircraft : [];
}

export async function fetchLocalAircraftProfilesJson(profilesPath) {
  const response = await fetch(profilesPath);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return await response.json();
}
